var Debouncer = require('../lib/Debouncer.js');

var plauditConfig = (function($){
	return {
		body: $(document.body)
		,html: $(document.documentElement)
		,win: $(window)
		,getForms: function() {
			var _forms = $('form');
			return _forms;
		}
		,main: $('main')
		,state: {
			prev: null
			,curr: null
			,changed: false
		}
		,scrollDistance: 45
	};
})(jQuery);

var plauditUI = (function($){
	"use strict";

	return {
		common: function(){
			// Scroll page to messages if there are any and the user is not already scrolled down
			if ( $(document).scrollTop() == 0 ) {
				var $msgs = $('.messages');
				if ( $msgs.length ){
					$('html, body').stop(true).animate({'scrollTop' : ($msgs.first().offset().top - 10)}, 1000, 'easeOutQuint');
				}
			}

			(function detectAndroidBrowser(html, userAgent) {
			if ( /android\s(\d)/ig.test( userAgent ) && !/chrome/ig.test( userAgent ) ) {
				var versionOs = /[\d\.]+/.exec( /android\s[\d\.]*/ig.exec( userAgent ) );
				var versionBrowser = /[\d\.]+/.exec( /version\/.*\s/ig.exec( userAgent ) );
				html
					.addClass( 'android-os-' + versionOs )
					.addClass( ' android-browser-' + versionBrowser );
			}})(plauditConfig.html, navigator.userAgent);

			// Prevent double submit of forms
			var formSubmittedClass = "wait";
			var formButtons = "input[type=submit], input[type=button], button";
			var pauseForms = function () {
				plauditConfig.getForms().addClass(formSubmittedClass);
				plauditConfig.getForms().find(formButtons)
					.css({"visibility": "hidden"})
					.after("<span class='wait'><i></i><span>Please wait…</span></span>")
					.parent().addClass('waiting');
			}
			var releaseForms = function () {
				plauditConfig.getForms().removeClass(formSubmittedClass);

				plauditConfig.getForms().find(formButtons)
					.css({"visibility": ""})
					.parent().removeClass('waiting')
					.find('.wait').remove();
			}
			$(document).on('ajaxSend submit', 'form', function(evt){
				var $form = $(this);
				if( $form.hasClass(formSubmittedClass) ){
					evt.preventDefault();
					return false;
				} else {
					pauseForms();
				}
			});
			$(document).on('ajaxComplete', function(event) {
				releaseForms();
			});

			$(document).on('ajaxSend', function(event) {
				plauditConfig.body.addClass('ajaxInProgress');
			});
			$(document).on('ajaxComplete', function(event) {
				plauditConfig.body.removeClass('ajaxInProgress');
			});

			// Add a class to fieldArea when user is hovering over or has focus on a form field. We use this to show any field specific messages.
			var fieldAreaFocusClass = "fieldAreaFocus";
			var fieldAreaHoverClass = "fieldAreaHover";
			plauditConfig.body.on("mouseenter mouseleave focus blur", "input, select, textarea", function(ev) {
				var $input = $(this)
					,$area = $input.closest(".fieldArea");
				if ( !$area.length ) { return };

				var evType = ev.type
					,isSelectOne = ($input.get(0).type === "select-one");

				if ( evType === "mouseenter" ) {
					$area.addClass( fieldAreaHoverClass );
				} else if (
						(evType === "mouseleave" && !$area.hasClass( fieldAreaFocusClass ) ) ||
						(evType === "blur") ||
						(evType === "focusout")
					) {
					$area.removeClass( fieldAreaHoverClass );
					$area.removeClass( fieldAreaFocusClass );
				} else if ( evType.indexOf("focus") > -1 ) {
					if ( isSelectOne && $area.hasClass( fieldAreaHoverClass ) ) { // Remove if user clicked to open a select one field. Otherwise the arrow is partially visible.
						$area.removeClass( fieldAreaFocusClass );
					} else {
						$area.addClass( fieldAreaFocusClass );
					}
				}
			});

			(function growingTextAreas() {
				plauditConfig.body.on("focus", "textarea", function(ev) {
					$(this).addClass( 'expanded' );
				})
				plauditConfig.body.on("blur", "textarea", function(ev) {
					var $that = $(this);
					if (!$that.val()){
						window.setTimeout(function () { $that.removeClass( 'expanded' ); }, 1000);
					}
				})
			})();


			(function addClassOnScroll(win, body, distance){
				var css = "scrolled";
				var distance = distance || 72;
				var eventHandler = function () {
					if ( win.scrollTop() < distance ) {
						body.removeClass( css );
					} else {
						body.addClass( css );
					}
				}
				eventHandler();
				win.on('scroll.addClass', eventHandler);
			})(plauditConfig.win, plauditConfig.body, plauditConfig.scrollDistance);


			(function trackBrowsingState(win, state){
				function getState(){
					return $('header .triggers').css('display') == 'block' ? 'responsive' : 'desktop';
				}
				function setState(){
					state.curr = getState();
				}
				function handleEvent() {
					state.prev = state.curr;
					setState();
					state.changed = state.prev != state.curr;
					if (state.prev != state.curr){
						win.trigger( "browserState:change" );
					}
				}
				setState();
				handleEvent()
				win.on('resize.trackState', handleEvent);
			})(plauditConfig.win, plauditConfig.state);
		} // End common

		/**
		 * Scroll page to messages if there are any and the user is not already scrolled down
		 */
		,scrollToMessages: function() {
			var $msgs = $('.messages');
			if ($msgs.length) {
				$('html, body').stop(true);

				var top = $msgs.first().offset().top - 50;
				var left = $msgs.first().offset().left - 50;

				var sectionScroller = $(document.body).data('sectionScroller');
				if (sectionScroller !== undefined) {
					sectionScroller.animateTo(left, top);
				} else {
					$('body').animate({'scrollTop' : top}, 1000, 'easeOutQuart');
				}
			}
		}

		,arrayDifference: function(a1, a2){
			var result = [];
			for (var i = 0; i < a1.length; i++) {
				if (a2.indexOf(a1[i]) === -1) {
					result.push(a1[i]);
				}
			}
			return result;
		} // arrayDifference()


		,homepage: function() {
			var elem = $('body._entry');
			if (elem.length==0){
				return;
			}

			var photoWrap = elem.find('#main .photo');
			photoWrap.cycle({
				speed: 600,
				manualSpeed: 100,
				slides: '.slide'
			});

			var stories = elem.find('#main .story-wrap').prepend('<div class=cycle-pager></div>');
			stories.cycle({
			    speed: 600,
			    manualSpeed: 100,
			    slides: '.story',
			    autoHeight: 'calc'
			});
		} // homepage()


		,regionsMap: function(){
			var elem = $('#chooseAProject');
			if (elem.length==0){
				return;
			}
			// Define things
			var africanCountries = {
				'DZA' : ['DZ', 'DZA', 'Algeria'],
				'AGO' : ['AO', 'AGO', 'Angola'],
				'BEN' : ['BJ', 'BEN', 'Benin'],
				'BWA' : ['BW', 'BWA', 'Botswana'],
				'BFA' : ['BF', 'BFA', 'Burkina Faso'],
				'BDI' : ['BI', 'BDI', 'Burundi'],
				'CMR' : ['CM', 'CMR', 'Cameroon'],
				'CAF' : ['CF', 'CAF', 'Central African Republic'],
				'TCD' : ['TD', 'TCD', 'Chad'],
				'COM' : ['KM', 'COM', 'Comoros'],
				'COG' : ['CG', 'COG', 'Congo (Brazzaville)'],
				'COD' : ['CD', 'COD', 'Congo, Democratic Republic of the'],
				'CIV' : ['CI', 'CIV', 'Côte d\'Ivoire'],
				'DJI' : ['DJ', 'DJI', 'Djibouti'],
				'EGY' : ['EG', 'EGY', 'Egypt'],
				'GNQ' : ['GQ', 'GNQ', 'Equatorial Guinea'],
				'ERI' : ['ER', 'ERI', 'Eritrea'],
				'ETH' : ['ET', 'ETH', 'Ethiopia'],
				'GAB' : ['GA', 'GAB', 'Gabon'],
				'GMB' : ['GM', 'GMB', 'The Gambia'],
				'GHA' : ['GH', 'GHA', 'Ghana'],
				'GIN' : ['GN', 'GIN', 'Guinea'],
				'GNB' : ['GW', 'GNB', 'Guinea-Bissau'],
				'KEN' : ['KE', 'KEN', 'Kenya'],
				'LSO' : ['LS', 'LSO', 'Lesotho'],
				'LBR' : ['LR', 'LBR', 'Liberia'],
				'LBY' : ['LY', 'LBY', 'Libya'],
				'MDG' : ['MG', 'MDG', 'Madagascar'],
				'MWI' : ['MW', 'MWI', 'Malawi'],
				'MLI' : ['ML', 'MLI', 'Mali'],
				'MRT' : ['MR', 'MRT', 'Mauritania'],
				'MUS' : ['MU', 'MUS', 'Mauritius'],
				'MAR' : ['MA', 'MAR', 'Morocco'],
				'MOZ' : ['MZ', 'MOZ', 'Mozambique'],
				'NAM' : ['NA', 'NAM', 'Namibia'],
				'NER' : ['NE', 'NER', 'Niger'],
				'NGA' : ['NG', 'NGA', 'Nigeria'],
				'RWA' : ['RW', 'RWA', 'Rwanda'],
				'STP' : ['ST', 'STP', 'Sao Tome and Principe'],
				'SEN' : ['SN', 'SEN', 'Senegal'],
				'SYC' : ['SC', 'SYC', 'Seychelles'],
				'SLE' : ['SL', 'SLE', 'Sierra Leone'],
				'SOM' : ['SO', 'SOM', 'Somalia'],
				'ZAF' : ['ZA', 'ZAF', 'South Africa'],
				'SSD' : ['SS', 'SSD', 'South Sudan'],
				'SDN' : ['SD', 'SDN', 'Sudan'],
				'SWZ' : ['SZ', 'SWZ', 'Swaziland'],
				'TZA' : ['TZ', 'TZA', 'Tanzania *, United Republic of'],
				'TGO' : ['TG', 'TGO', 'Togo'],
				'TUN' : ['TN', 'TUN', 'Tunisia'],
				'UGA' : ['UG', 'UGA', 'Uganda'],
				'ESH' : ['EH', 'ESH', 'Western Sahara'],
				'ZMB' : ['ZM', 'ZMB', 'Zambia'],
				'ZWE' : ['ZW', 'ZWE', 'Zimbabwe']
			}

			var colorArr = [];
			var linksArr = [];

			var data = new google.visualization.DataTable();
			data.addColumn('string', 'Country');
			data.addColumn('number', 'Value');
			data.addColumn({type:'string', role:'tooltip'});

			elem.find('a.regionName').each(function(i) {
				var $this = $(this);
				linksArr.push( this );
				colorArr.push('#' + $this.data('color'));
				var countryData = africanCountries[$this.data('code')];
				data.addRows([[{v:countryData[0], f:countryData[2]}, i, 'Click to view']]);
				delete africanCountries[$this.data('code')];
			});

			// add null values to map
			for (var i in africanCountries){
				var countryData = africanCountries[i];
				data.addRows([[{v:countryData[0], f:countryData[2]}, null, '-']]);
			}

			// chart options
			var options = {
				region : '002',
				backgroundColor : {
					fill : 'transparent',
				},
				defaultColor: '#aaa',
				datalessRegionColor : '#fff',
				displayMode : 'regions',
				enableRegionInteractivity : 'true',
				colorAxis : {
					minValue : 0,
					maxValue : colorArr.length - 1,
					colors : colorArr
				},
				keepAspectRatio : true,
				width : '100%',
				legend : 'none',
				tooltip : {textStyle: {color: '#000'}, showColorCode: true, trigger: 'focus'}
			}

			var draw = function () {
				wrapper.removeClass('resize').find('#map').remove();

				var chart = new google.visualization.GeoChart( $('<div id="map" class="map" />').appendTo(wrapper).get(0) );

				var width = wrapper.width();
				options.height = width < 600 ? width : 600;

				google.visualization.events.addListener(chart, 'select', function() {
						var selection = chart.getSelection();
						if (selection.length == 1) {
							var selectedRow = selection[0].row;
							var selectedRegion = data.getValue(selectedRow, 0);
							if (typeof linksArr[selectedRow] !== 'undefined' && linksArr[selectedRow] != '') {
								window.location = linksArr[selectedRow].href;
							}
						}
					});
				chart.draw(data, options);
				wrapper.removeClass('inactive');
			};
			function widthChanged() {
				return plauditConfig.win.width() != plauditConfig.winWidth;
			}

			// create our map wrapper
			var wrapper = $('<div id="map-wrapper" class="map-wrap inactive"><h3>Select a country from the map, or choose a project from the list below:</h3></div>');
			elem.before(wrapper);
			// draw the map
			draw();
			plauditConfig.winWidth = plauditConfig.win.width();

			// event binding
			plauditConfig.win.on('resize.resize', function() {
				if (widthChanged()) {
					wrapper.addClass('resize')
				}
			});
			plauditConfig.win.on('resize.charts', new Debouncer(function() {
				if (widthChanged()) {
					draw();
				}
			}).run);
		} // regionsMap


		,responsiveMenu: function () {
			var config = {
				menu: '#menu'
				,menuActive: false
				,menuCSS: 'menu-open'
				,subCSS: 'pulled-menu'
				,subOpenedCSS: 'open'
				,subTarget: '.child-wrap'
				,subTrigger: '.has-child > a'
				,triggers: '#trigger-menu-open,#trigger-menu-close,#menu-overlay'
				,triggerEvent: 'click'
			};
			var menu = $(config.menu);
			(function () {
				var c = config;
				var $subtarget = menu.find(c.subTarget);

				function toggleMenu(evt) {
					evt.preventDefault();
					plauditConfig.html.toggleClass( c.menuCSS );
				}
				function toggleSub(evt) {
					evt.preventDefault();
					var $target = $((evt.target.tagName == 'SPAN') ? evt.target.parentNode : evt.target);
					$target.next().slideToggle(400,'easeOutExpo');
					$target.parent('li').toggleClass( c.subOpenedCSS );
				}
				function begSub() {
					menu.toggleClass(c.subCSS);
					$subtarget.filter('.active').parents('li').addClass( c.subOpenedCSS )
					$subtarget.stop().not('.active').slideUp();
				}
				function endSub() {
					menu.toggleClass(c.subCSS);
					$subtarget.parents('li').removeClass( c.subOpenedCSS )
					$subtarget.stop().slideDown().attr('style', '');
				}
				function attachEventsWin() {
					if ( c.menuActive===true ){
						return;
					}
					$(c.triggers).on(c.triggerEvent, toggleMenu);
					begSub();
					menu.on('click.menu', c.subTrigger, toggleSub);
				}
				function detachEventsWin() {
					if ( c.menuActive===false ){
						return;
					}
					$(c.triggers).off(c.triggerEvent, toggleMenu);
					endSub();
					menu.off('click.menu');
				}
				function resizeEventHandler() {
					menu.removeClass( c.menuCSS );
					if ( plauditConfig.state.curr=='responsive' ) {
						attachEventsWin();
						c.menuActive = true;
					} else {
						detachEventsWin();
						c.menuActive = false;
					}
				}
				resizeEventHandler();

				plauditConfig.win.on('browserState:change', resizeEventHandler);
			})();
		} // responsiveMenu()

		,setupPersistForm: function(){
			var $persistFormField = $("input[name='persistForm.name']");
			if ( $persistFormField.length==0 ) {
				return;
			}

			var baseHref = $('base').attr('href');

			var ajaxPersistForm = function(action, $form) {
				var data = "action="+action+"&" + $form.serialize();

				$.ajax({
					type: "post",
					url: baseHref + "/form-data",
					data: data,
					dataType: "json"
				})
				.done(function(data, textStatus, jqXHR) {
					// If form has been submitted then done allow it to be edited.
					if ( typeof(data.status) != "undefined" && data.status == "SUBMITTED" ) {
						$('#containerRegistration input, #containerRegistration select, #containerRegistration textarea').attr('readonly', 'readonly');
					}

					if ( typeof(data.data) != "undefined" ) {
						var formData = data.data;
						for (var prop in formData) {
							var value = formData[prop];

							// Fill fields
							var field = $("[name=\"" + prop + "\"]", $form);
							if ( typeof(field) != "undefined" ) {
								if (typeof(field.prop("tagName")) != "undefined") {
									var tagName = field.prop("tagName").toLowerCase();
									if (tagName == "input") {
										var type = field.prop("type");
										if (type == "radio" || type == "checkbox") {
											field.prop('checked', false);
											if ($.isArray(value)) {
												for (i=0; i < value.length; i++) {
													var item = value[i];
													field.filter('[value="'+item+'"]').prop('checked', true);
												}
											} else {
												field.filter('[value="'+value+'"]').prop('checked', true);
											}
										} else {
											if ( type !== "file" ) {
												field.val(value);
											}
										}
									} else {
										// textarea, select
										field.val(value);
									}
								}
							}
						}
					}
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					if ( typeof(console) != "undefined" ) {
						console.log("AJAX Failed: " + textStatus + " -- " + errorThrown);
					}
				});
			}; // ajaxPersistForm()

			// Setup each field to trigger saving of data
			$persistFormField.each(function(i){
				var $this = $(this);
				var name = $this.val();

				var $form = $this.closest('form');

				ajaxPersistForm("load", $form);

				var saveTimeout;
				var saveFunction = function() {
					ajaxPersistForm("save", $form);
				};
				$form.find("input, select, textarea, select").change(function() {
					if ( typeof(saveTimeout) != "undefined" ) {
						clearTimeout(saveTimeout);
					}
					saveTimeout = setTimeout(saveFunction, 1500);

				});
			});

			// Additional form setup.
			(function(){
				function getURLParameter(name) {
				    return decodeURI(
				        (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
				    );
				}
				var textareas = $('textarea').filter('[class*="word-limit-"]');
				var regex = /\s+/gi;

				textareas.each(function() {
					$(this).data('word', $(this).attr('class').replace(/\D/gi,'') );
				});

				textareas.on('change keyup blur', function (){
					var value = $(this).val();
					var wordLimit = $(this).data('word');
					var wordLength = value.trim().replace(regex, ' ').split(' ').length;
					if ( wordLength > wordLimit ) {
						// Split the string on first 200 words and rejoin on spaces
						var trimmed = value.replace(/(\r\n|\n|\r)/g, '||');
						trimmed = trimmed.split(/\s+/gi, wordLimit).join(' ');
						trimmed = trimmed.replace(/\|\|/g, "\n");
						// Add a space at the end to make sure more typing creates new words
						$(this).val(trimmed + " ");
					}
				})
			})();
		} // setupPersistForm
	};
})(jQuery);
window.scrollToMessages = plauditUI.scrollToMessages;

jQuery(function(){
	plauditUI.common();
	plauditUI.responsiveMenu();
	plauditUI.setupPersistForm();
	plauditUI.homepage();
});

module.exports = plauditUI;
